import { render, staticRenderFns } from "./SalesListFunc.vue?vue&type=template&id=19a75b23&scoped=true"
import script from "./SalesListFunc.vue?vue&type=script&lang=js"
export * from "./SalesListFunc.vue?vue&type=script&lang=js"
import style0 from "./SalesListFunc.vue?vue&type=style&index=0&id=19a75b23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a75b23",
  null
  
)

export default component.exports